import { render } from "./WordSearchPopupComponent.vue?vue&type=template&id=762dec7a&scoped=true"
import script from "./WordSearchPopupComponent.vue?vue&type=script&lang=js"
export * from "./WordSearchPopupComponent.vue?vue&type=script&lang=js"

import "./WordSearchPopupComponent.vue?vue&type=style&index=0&id=762dec7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762dec7a"]])

export default __exports__